<template>
  <div class="w-full h-full py-5 flex flex-col gap-5">
    <FlashMessage v-if="this.messages.text != ''" :message="this.messages" />
    <h1 class="text-lg lg:text-2xl font-semibold dark_text">Today Schedule</h1>
    <div class="w-full flex justify-start gap-5 items-center">
      <button
        @click="add_class = true"
        class="attendance_btn px-4 py-2 rounded-lg uppercase text-xs font-semibold"
      >
        add class
      </button>
      <button
        @click="re_assign = true"
        class="attendance_btn px-4 py-2 rounded-lg uppercase text-xs font-semibold"
      >
        re-assign class
      </button>
    </div>
    <div class="w-full overflow-scroll">
      <table class="min-w-full">
        <thead>
          <tr class="text-left bg-[#18469d] text whitespace-nowrap text-sm">
            <th class="px-6 py-3">S.No</th>
            <th class="px-6 py-3">Course</th>
            <th class="px-6 py-3">Subject/Subject Code</th>
            <th class="px-6 py-3">Student Count</th>
            <th class="px-6 py-3">Practical</th>
            <th class="px-6 py-3">Elective</th>
            <th class="px-6 py-3">Semester</th>
            <th class="px-6 py-3">Section</th>
            <th class="px-6 py-3">Session</th>
            <th class="px-6 py-3">Status</th>
            <th class="px-6 py-3">Day</th>
            <th class="px-6 py-3">Date</th>
          </tr>
        </thead>
        <tbody v-if="loading" class="bg-[#e5e7eb] w-fit">
          <tr class="w-full">
            <td colspan="12" class="text-center py-6">
              <div class="flex items-center justify-center">
                <img src="@/assets/attendance/loading.gif" alt="" />
              </div>
            </td>
          </tr>
        </tbody>
        <tbody v-else>
          <template v-if="attendance_list.length > 0">
            <tr
              v-for="(list, index) in attendance_list"
              :key="index"
              class="border-b border-[#afdaec] text-left whitespace-nowrap text-sm"
            >
              <td class="px-6 py-3">{{ index + 1 }}</td>
              <td class="px-6 py-3">{{ list.course }}</td>
              <td class="px-6 py-3">
                <span
                  v-if="list.status === 'Completed'"
                  class="text-gray-600 cursor-not-allowed"
                >
                  {{ list.subject }} - {{ list.subject_code }}
                </span>
                <router-link
                  v-else
                  :to="{
                    name: 'AttendanceListView',
                    params: {
                      subject_pk: list.subject_pk,
                      faculty_time_table_pk: list.timetable_pk,
                      session: `${list.date}-${list.session}`,
                    },
                  }"
                  class="text-textblues cursor-pointer"
                >
                  {{ list.subject }} - {{ list.subject_code }}
                </router-link>
              </td>
              <td class="px-6 py-3">{{ list.student_count }}</td>
              <td class="px-6 py-3">
                <span v-if="list.practical != null">{{ list.practical }}</span
                ><span v-else>---</span>
              </td>
              <td class="px-6 py-3">
                <span v-if="list.elective != null">{{ list.elective }}</span
                ><span v-else>---</span>
              </td>
              <td class="px-6 py-3">{{ list.semester }}</td>
              <td class="px-6 py-3">{{ list.section }}</td>
              <td class="px-6 py-3">{{ list.session }}</td>
              <td class="px-6 py-3">{{ list.status }}</td>
              <td class="px-6 py-3">{{ list.day }}</td>
              <td class="px-6 py-3">{{ list.date }}</td>
            </tr>
          </template>
          <tr v-else>
            <td colspan="12" class="px-6 py-3 text-center">No Data Found</td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td colspan="12" class="p-6 bg-[#18469d]"></td>
          </tr>
        </tfoot>
      </table>
    </div>
    <div class="flex flex-col gap-2">
      <h1 class="text-lg lg:text-2xl font-semibold dark_text">
        Substitute Class
      </h1>
      <p v-if="substitute_list == null" class="text-sm text-gray-600">
        No substitute class today!
      </p>

      <div v-else class="w-full overflow-scroll">
        <table class="min-w-full">
          <thead>
            <tr class="text-left bg-[#18469d] text whitespace-nowrap text-sm">
              <th class="px-6 py-3">S.No</th>
              <th class="px-6 py-3">Course</th>
              <th class="px-6 py-3">Subject/Subject Code</th>
              <th class="px-6 py-3">Student Count</th>
              <th class="px-6 py-3">Practical</th>
              <th class="px-6 py-3">Elective</th>
              <th class="px-6 py-3">Semester</th>
              <th class="px-6 py-3">Section</th>
              <th class="px-6 py-3">Session</th>
              <th class="px-6 py-3">Status</th>
              <th class="px-6 py-3">Day</th>
              <th class="px-6 py-3">Date</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(list, index) in substitute_list"
              :key="index"
              class="border-b border-[#afdaec] text-left whitespace-nowrap text-sm"
            >
              <td class="px-6 py-3">{{ index + 1 }}</td>
              <td class="px-6 py-3">{{ list.course }}</td>
              <td class="px-6 py-3">
                <span
                  v-if="list.status === 'Completed'"
                  class="text-gray-400 cursor-not-allowed font-bold"
                >
                  {{ list.subject }} - {{ list.subject_code }}
                </span>
                <router-link
                  v-else
                  :to="{
                    name: 'AttendanceListView',
                    params: {
                      subject_pk: list.subject_pk,
                      faculty_time_table_pk: list.timetable_pk,
                      session: `${list.date}-${list.session}`,
                    },
                  }"
                  class="text-textblues cursor-pointer"
                >
                  {{ list.subject }} - {{ list.subject_code }}</router-link
                >
              </td>
              <td class="px-6 py-3">{{ list.student_count }}</td>
              <td class="px-6 py-3">
                <span v-if="list.practical != null">{{ list.practical }}</span
                ><span v-else>---</span>
              </td>
              <td class="px-6 py-3">
                <span v-if="list.elective != null">{{ list.elective }}</span
                ><span v-else>---</span>
              </td>
              <td class="px-6 py-3">{{ list.semester }}</td>
              <td class="px-6 py-3">{{ list.section }}</td>
              <td class="px-6 py-3">{{ list.session }}</td>
              <td class="px-6 py-3">{{ list.status }}</td>
              <td class="px-6 py-3">{{ list.day }}</td>
              <td class="px-6 py-3">{{ list.date }}</td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td colspan="12" class="p-6 bg-[#18469d]"></td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
    <!-- add class start  -->
    <div
      v-if="add_class"
      class="flex items-center justify-center w-full h-full fixed top-0 left-0 z-50 bg-black bg-opacity-60"
    >
      <div
        class="bg-white p-6 text-left gap-y-5 flex flex-col justify-center w-[90%] lg:w-[70%] h-[80%] lg:h-auto rounded-xl relative !z-999"
      >
        <h3 class="text-lg font-semibold dark_text text-left">Add Class</h3>
        <form
          @submit.prevent="addClass"
          class="flex flex-col gap-5 overflow-scroll"
        >
          <div class="flex flex-col lg:flex-row gap-5">
            <!-- user  -->
            <div class="w-full flex flex-col gap-2">
              <label for="" class="font-semibold text-sm"
                >User <span class="text-red-500">*</span></label
              >
              <select
                name="user"
                id="user"
                class="px-4 py-2 rounded-md border text-md focus:outline-none focus:ring-0 bg_white"
              >
                <option
                  :value="el.user_email"
                  v-for="el in user_list"
                  :key="el"
                  selected
                  disabled
                >
                  {{ el.user_email }}
                </option>
              </select>
            </div>
            <!-- program  -->
            <div class="w-full flex flex-col gap-2">
              <label for="" class="font-semibold text-sm"
                >Program <span class="text-red-500">*</span></label
              >
              <select
                name="program"
                id="program"
                class="px-4 py-2 rounded-md border text-md focus:outline-none focus:ring-0 bg_white"
              >
                <option
                  :value="el.program_name"
                  v-for="el in user_list"
                  :key="el"
                  selected
                  disabled
                >
                  {{ el.program_name }}
                </option>
              </select>
            </div>
          </div>
          <div class="flex flex-col lg:flex-row gap-5">
            <!-- department -->
            <div class="w-full flex flex-col gap-2">
              <label for="" class="font-semibold text-sm"
                >Department <span class="text-red-500">*</span></label
              >
              <select
                name="department"
                id="department"
                class="px-4 py-2 rounded-md border uppercase text-md focus:outline-none focus:ring-0 bg_white"
              >
                <option
                  :value="el.department"
                  v-for="el in user_list"
                  :key="el"
                  selected
                  disabled
                >
                  {{ el.department }}
                </option>
              </select>
            </div>
            <!-- subject name  -->
            <div class="w-full flex flex-col gap-2">
              <label for="" class="font-semibold text-sm"
                >Sub Name <span class="text-red-500">*</span></label
              >
              <select
                name="sub_name"
                id="sub_name"
                v-model="selected_sub"
                @change="getCodeList(selected_sub)"
                class="px-4 py-2 rounded-md border text-md focus:outline-none focus:ring-0 bg_white"
              >
                <option value="" selected>Select Sub Name</option>
                <option
                  :value="el.name"
                  v-for="el in subject_list"
                  :key="el.id"
                >
                  {{ el.name }}
                </option>
              </select>
            </div>
          </div>
          <div class="flex flex-col lg:flex-row gap-5">
            <!-- subject code  -->
            <div class="w-full flex flex-col gap-2">
              <label for="" class="font-semibold text-sm"
                >Sub Code <span class="text-red-500">*</span></label
              >
              <select
                name="sub_code"
                id="sub_code"
                class="px-4 py-2 rounded-md border text-md focus:outline-none focus:ring-0 bg_white"
              >
                <option value="" selected>Select Sub Code</option>
                <option :value="el" v-for="el in subject_code_list" :key="el">
                  {{ el }}
                </option>
              </select>
            </div>
            <!-- section  -->
            <div class="w-full flex flex-col gap-2">
              <label for="" class="font-semibold text-sm"
                >Section <span class="text-red-500">*</span></label
              >
              <select
                name="section"
                id="section"
                class="px-4 py-2 rounded-md border text-md focus:outline-none focus:ring-0 bg_white"
              >
                <option value="" selected>Select Section</option>
                <option :value="el" v-for="el in section_list" :key="el">
                  {{ el }}
                </option>
              </select>
            </div>
          </div>
          <div class="flex flex-col lg:flex-row gap-5">
            <!-- Semester  -->
            <div class="w-full flex flex-col gap-2">
              <label for="" class="font-semibold text-sm"
                >Semester <span class="text-red-500">*</span></label
              >
              <select
                name="semester"
                id="semester"
                class="px-4 py-2 rounded-md border text-md focus:outline-none focus:ring-0 bg_white"
              >
                <option value="" selected>Select Semester</option>
                <option :value="el" v-for="el in semester_list" :key="el">
                  {{ el }}
                </option>
              </select>
            </div>
            <!-- session -->
            <div class="w-full flex flex-col gap-2">
              <label for="" class="font-semibold text-sm"
                >Session <span class="text-red-500">*</span></label
              >
              <select
                name="session"
                id="session"
                class="px-4 py-2 rounded-md border text-md focus:outline-none focus:ring-0 bg_white"
              >
                <option value="" selected>Select Session</option>
                <option :value="el.id" v-for="el in session_list" :key="el.id">
                  {{ el.name }}
                </option>
              </select>
            </div>
          </div>
          <div class="flex flex-col lg:flex-row gap-5">
            <!-- Day  -->
            <div class="w-full lg:w-1/2 flex flex-col gap-2">
              <label for="" class="font-semibold text-sm"
                >Day <span class="text-red-500">*</span></label
              >
              <select
                name="day"
                id="day"
                class="px-4 py-2 rounded-md border text-md focus:outline-none focus:ring-0 bg_white"
              >
                <option value="" selected>Select Day</option>
                <option :value="el" v-for="el in day_list" :key="el">
                  {{ el }}
                </option>
              </select>
            </div>
          </div>

          <div class="w-full flex justify-end items-center gap-5">
            <button
              type="button"
              @click="add_class = false"
              class="px-4 py-2 text-sm font-semibold rounded-md bg-[#d1d5db] text-[#596270]"
            >
              Cancel
            </button>
            <div class="flex justify-end items-center gap-3">
              <button
                type="submit"
                :disabled="disable_submit == true"
                :class="
                  this.disable_submit == true
                    ? 'bg-gray-200 text-black cursor-not-allowed'
                    : 'attendance_btn hover:bg-hover cursor-pointer text-white'
                "
                class="px-4 py-2 text-sm font-semibold rounded-md"
              >
                Submit
              </button>
              <img
                v-if="disable_submit"
                src="@/assets/loading.gif"
                alt="loading"
                class="w-6 h-6 object-contain"
              />
            </div>
            <!-- <button
              type="submit"
              class="attendance_btn px-4 py-2 text-sm font-semibold rounded-md"
            >
              Submit
            </button> -->
          </div>
        </form>
      </div>
    </div>

    <!-- add class end  -->
    <!-- re assign instructor start  -->
    <div
      v-if="re_assign"
      class="flex items-center justify-center w-full h-full fixed top-0 left-0 z-50 bg-black bg-opacity-60"
    >
      <div
        class="bg-white p-6 text-left gap-y-5 flex flex-col justify-center w-[90%] lg:w-[65%] rounded-xl relative !z-999"
      >
        <h3 class="text-lg font-semibold dark_text text-left">
          Re-assign Class
        </h3>
        <form @submit.prevent="reAssign" class="w-full flex flex-col gap-5">
          <div class="flex flex-col lg:flex-row gap-5 w-full">
            <div class="w-full lg:w-1/2 flex flex-col gap-2">
              <label for="" class="font-semibold text-sm"
                >Today Class <span class="text-red-500">*</span></label
              >
              <select
                name="today_class"
                id="today_class"
                v-model="reassign_class"
                @change="getStaffList(reassign_class)"
                class="px-4 py-2 rounded-md border text-md focus:outline-none focus:ring-0 bg_white"
              >
                <option value="" selected>Select Class</option>

                <option :value="el.pk" v-for="el in class_list" :key="el">
                  {{ el.sub_name }} - {{ el.sub_code }}
                </option>
              </select>
            </div>
            <div class="w-full lg:w-1/2 flex flex-col gap-2">
              <label for="" class="font-semibold text-sm"
                >Select Staff <span class="text-red-500">*</span></label
              >
              <select
                name="staff"
                id="staff"
                v-model="reassign_email"
                class="px-4 py-2 rounded-md border text-md focus:outline-none focus:ring-0 bg_white"
              >
                <option value="" selected>Select Staff</option>

                <option
                  :value="el.faculty_email"
                  v-for="el in staff_list"
                  :key="el"
                >
                  {{ el.faculty_name }}
                </option>
              </select>
            </div>
          </div>

          <div class="w-full flex justify-end items-center gap-5">
            <button
              type="button"
              @click="re_assign = false"
              class="px-4 py-2 text-sm font-semibold rounded-md bg-[#d1d5db] text-[#596270]"
            >
              Cancel
            </button>
            <div class="flex justify-end items-center gap-3">
              <button
                type="submit"
                :disabled="disable_submit == true"
                :class="
                  this.disable_submit == true
                    ? 'bg-gray-200 text-black cursor-not-allowed'
                    : 'attendance_btn hover:bg-hover cursor-pointer text-white'
                "
                class="px-4 py-2 text-sm font-semibold rounded-md"
              >
                Submit
              </button>
              <img
                v-if="disable_submit"
                src="@/assets/loading.gif"
                alt="loading"
                class="w-6 h-6 object-contain"
              />
            </div>
          </div>
        </form>
      </div>
    </div>
    <!-- re assign instructor end  -->
  </div>
</template>

<script>
import axios from "axios";
import FlashMessage from "@/components/FlashMessage.vue";

export default {
  data() {
    return {
      loading: true,
      attendance_list: [],
      substitute_list: null,
      class_list: null,
      re_assign: false,
      add_class: false,
      staff_list: null,
      user_list: null,
      subject_list: null,
      subject_code_list: null,
      section_list: null,
      semester_list: null,
      session_list: null,
      day_list: null,
      sub_id: "",
      reassign_class: "",
      reassign_email: "",
      messages: {
        text: "",
        type: "null",
      },
      selected_sub: "",
      disable_submit: false,
    };
  },
  components: { FlashMessage },
  created() {
    this.getTodaySchedule();
    this.getSubstituteClass();
    this.getTodayClass();
    // get add class drop down
    this.getAddClass();
    this.getAddClassSub();
  },
  methods: {
    // get apis
    getTodaySchedule() {
      axios
        .get(
          `${
            process.env.VUE_APP_API_COMS
          }/faculty-admin/today-schedule-attendance/?Key=${localStorage.getItem(
            "LmsId"
          )}`
        )
        .then((resp) => {
          if (resp.data.status == 200) {
            this.attendance_list = resp.data.data;
            setTimeout(() => {
              this.loading = false;
            }, 600);
          }
        })
        .catch((err) => {
          console.log("error", err);
        })
        .finally(() => {
          setTimeout(() => {
            this.loading = false;
          }, 600);
        });
    },
    getSubstituteClass() {
      axios
        .get(
          `${
            process.env.VUE_APP_API_COMS
          }/faculty-admin/today-substitute-class/?Key=${localStorage.getItem(
            "LmsId"
          )}`
        )
        .then((resp) => {
          if (resp.data.status == 200) {
            this.substitute_list = resp.data.data;
            setTimeout(() => {
              this.loading = false;
            }, 600);
          }
        })
        .catch((err) => {
          console.log("error", err);
        });
    },

    getTodayClass() {
      axios
        .get(
          `${
            process.env.VUE_APP_API_COMS
          }/faculty-admin/re-assignment-class-list/?Key=${localStorage.getItem(
            "LmsId"
          )}`
        )
        .then((resp) => {
          if (resp.data.status == 200) {
            this.class_list = resp.data.data;
          }
        })
        .catch((err) => {
          console.log("error", err);
        });
    },
    getStaffList(id) {
      axios
        .get(
          `${
            process.env.VUE_APP_API_COMS
          }/faculty-admin/re-assignment-class-avilable-list/${id}/?Key=${localStorage.getItem(
            "LmsId"
          )}`
        )
        .then((resp) => {
          if (resp.data.status == 200) {
            this.staff_list = resp.data.data.staff_q;
          }
        })
        .catch((err) => {
          console.log("error", err);
        });
    },
    // add class drop down get api
    //
    getAddClass() {
      axios
        .get(
          `${
            process.env.VUE_APP_API_COMS
          }/faculty-admin/get-addclass-user/?Key=${localStorage.getItem(
            "LmsId"
          )}`
        )
        .then((resp) => {
          if (resp.data.status == 200) {
            this.user_list = resp.data.data;
          }
        })
        .catch((err) => {
          console.log("error", err);
        });
    },
    getAddClassSub() {
      axios
        .get(
          `${
            process.env.VUE_APP_API_COMS
          }/faculty-admin/get-addclass-subject/?Key=${localStorage.getItem(
            "LmsId"
          )}`
        )
        .then((resp) => {
          if (resp.data.status == 200) {
            this.subject_list = resp.data.data;
          }
        })
        .catch((err) => {
          console.log("error", err);
        });
    },
    getCodeList(id) {
      const sub_name = this.subject_list.filter((item) => {
        return item.name === id;
      });
      if (sub_name.length > 0) {
        this.sub_id = sub_name[0].id;
      }
      axios
        .get(
          `${
            process.env.VUE_APP_API_COMS
          }/faculty-admin/get-addclass-table-details/?subject_id=${
            this.sub_id
          }&Key=${localStorage.getItem("LmsId")}`
        )
        .then((resp) => {
          if (resp.data.status == 200) {
            this.subject_code_list = resp.data.data.sub_codes;
            this.semester_list = resp.data.data.semesters;
            this.section_list = resp.data.data.sections;
            this.session_list = resp.data.data.sessions;
            this.day_list = resp.data.data.days;
          }
        })
        .catch((err) => {
          console.log("error", err);
        });
    },
    // add class post api
    addClass(el) {
      this.disable_submit = true;
      const event = el.target;
      const add_class = {
        user_email: event.elements.user.value,
        program_name: event.elements.program.value,
        department: event.elements.department.value,
        subject_id: this.sub_id,
        sub_name: event.elements.sub_name.value,
        sub_code: event.elements.sub_code.value,
        semester: parseInt(event.elements.semester.value),
        section: event.elements.section.value,
        session_id: event.elements.session.value,
        day: event.elements.day.value,
      };
      axios
        .post(
          `${
            process.env.VUE_APP_API_COMS
          }/faculty-admin/add-class-store/?Key=${localStorage.getItem(
            "LmsId"
          )}`,
          add_class
        )
        .then((resp) => {
          if (resp.data.status == 201) {
            this.messages = {
              text: resp.data.message,
              type: "success",
            };
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
              this.add_class = false;
              this.disable_submit = false;
            }, 2500);
          } else if (resp.data.status == 208) {
            this.messages = {
              text: resp.data.message,
              type: "success",
            };
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
              this.add_class = false;
              this.disable_submit = false;
            }, 2500);
          }
        })
        .catch((err) => {
          console.log("error", err);
        })
        .finally(() => {
          this.getTodaySchedule();
        });
    },
    // re assign class post api
    reAssign() {
      this.disable_submit = true;
      const re_assign = {
        faculty_table_pk: this.reassign_class,
        staff_email: this.reassign_email,
      };
      axios
        .post(
          `${
            process.env.VUE_APP_API_COMS
          }/faculty-admin/re-assignment-class-store/?Key=${localStorage.getItem(
            "LmsId"
          )}`,
          re_assign
        )
        .then((resp) => {
          if (resp.data.status == 200) {
            this.messages = {
              text: resp.data.message,
              type: "success",
            };
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
              this.re_assign = false;
              this.disable_submit = false;
            }, 2500);
          } else {
            this.disable_submit = false;
          }
        })
        .catch((err) => {
          console.log("error", err);
        });
    },
  },
};
</script>

<style></style>
